<template>
    <div class="row">
        <div class="col-12">
            <p class="text-center">Teklifi onaylamak için e-postanıza 6 haneli bir kod gönderilmiştir.</p>
        </div>
        <div class="col-12 mb-1">
            <div class="input-wrapper d-flex align-items-center justify-content-center">
                <pincode-input v-model="value.code" :length="6" placeholder="-"/>
            </div>
        </div>
        <div class="col-12 text-center">
            <button :disabled="waiting" class="btn btn-sm btn-light" v-on:click="sendVerificationCodeAgain">
                <b-spinner small class="mr-25" v-if="loading"></b-spinner>
                Yeniden Gönder
                <span v-if="waiting" class="ml-25">{{time}}</span>
            </button>
        </div>
    </div>
</template>

<script>
import PincodeInput from 'vue-pincode-input';
import CustomerApi from '@/api/customer'
import { BSpinner } from 'bootstrap-vue'
import moment from 'moment'
export default {
    components:{
        PincodeInput,
        BSpinner
    },
    props:{
        value:Object,
        id:[Number,String]
    },
    data(){
        return{
            time:"01:00",
            loading:false,
            waiting:false
        }
    },
    methods:{
        startTimer(){
            const timer = setInterval(()=>{
                if(this.waiting){
                    this.time = moment(this.time,'HH:mm').subtract(1,'second').format('HH:mm')
                }
                if(this.time == '00:00'){
                    this.waiting = false
                    clearInterval(timer)
                }
            },1000)
        },
        sendVerificationCodeAgain(){
            this.loading = true
            CustomerApi.DraftOffer.AgreementCode(this.id).then(res=>{
                if(res.data.Success) {
                    this.waiting = true
                    this.startTimer()
                }else this.$result(res)
                this.loading = false
            }).catch(err=>{
                this.$result(null,err)
            })
        }
    }

}
</script>